/**
 * Примесь добавляющая функциональность работы с корзиной.
 */
export default {
  methods: {
    normalizeCartItem (item) {
      return {
        offerId: item.offer.id,
        quantity: item.quantity
      }
    }
  }
}



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/mixins/Cart.js